import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=2a64f7a8&"
import script from "./Callback.js?vue&type=script&lang=js&"
export * from "./Callback.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports